<template >
  <base-material-card color="secondary" class="mx-10" icon="mdi-calendar-multiple-check">
    <template v-slot:after-heading>
      <div class="display-1 mt-2 font-weight-light">{{ $t('list_contab_reg') }}</div>
    </template>
    <v-layout class="mx-10" row>
      <v-tabs v-model="tabs" background-color="transparent" color="secondary" slider-color="secondary">
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-book-open-outline</v-icon>
          {{ $t('reg_title_stats') }}
        </v-tab>
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-book-open-outline</v-icon>
          {{ $t('reg_title_registration') }}
        </v-tab>
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-book-open-outline</v-icon>
          {{ $t('reg_title_cdx') }}
        </v-tab> <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-book-open-outline</v-icon>
          {{ $t('monthly_balances') }}
        </v-tab>
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-book-open-outline</v-icon>
          {{ $t('reg_title_nota') }}
        </v-tab>
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-book-open-outline</v-icon>
          {{ $t('reg_title_rendiconto') }}
        </v-tab>
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-cube-scan</v-icon>
          {{ $t('upload_invoice') }}
        </v-tab>
      </v-tabs>
    </v-layout>

    <v-tabs-items v-model="tabs" class="transparent tabs-container">
      <v-tab-item>
        <statistiche-cge></statistiche-cge>
      </v-tab-item>
      <v-tab-item>
        <list-cge type="M"></list-cge>
      </v-tab-item>
      <v-tab-item>
        <list-cge type="C"></list-cge>
      </v-tab-item>
      <v-tab-item>
        <list-cge type="S"></list-cge>
      </v-tab-item><v-tab-item>
        <list-cge type="N"></list-cge>
      </v-tab-item>
      <v-tab-item>
        <rendiconto-cge></rendiconto-cge>
      </v-tab-item>
      <v-tab-item>
        <upload-fattura></upload-fattura>
      </v-tab-item>
    </v-tabs-items>
  </base-material-card>
</template>
<script>
import listMovimenti from "@/app/contab/listMovimenti.vue";
import rendiconto from "@/app/contab/rendiconto.vue";
import statistiche from "@/app/contab/statistiche.vue";
import uploadFattura from "@/app/contab/uploadFattura.vue";

export default {
  name: "dashboard-contabile",
  components: {
    "list-cge": listMovimenti,
    "rendiconto-cge": rendiconto,
    "statistiche-cge": statistiche,
    "upload-fattura": uploadFattura
  },
  data() {
    return {
      tabs: 0
    };
  },
  methods: {},
  created() {
    this.tabs = parseInt(this.$route.query.tab, 10) || 0;
  },
  watch: {
    tabs(value) {
      // mantiene la tab corrente nell'URL per sopravvivere al reload della pagina
      this.$router
        .replace({ query: { ...this.$route.query, tab: value } })
        .catch((err) => {
          if (err.name !== "NavigationDuplicated") throw err;
        });
    },
  }
};
</script>
